import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customercare',
  templateUrl: './customercare.component.html',
  styleUrls: ['./customercare.component.scss']
})
export class CustomercareComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
